import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    },
  },
  paper: {
    padding: theme.spacing(2),
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  fileInput: {
    width: '97%',
    margin: '10px 0',
  },
  buttonSubmit: {
    marginBottom: 10,
  },
  [theme.breakpoints.down('sm')]: {
    paper: {
      marginRight: theme.spacing(10),
      marginLeft: theme.spacing(10),
    }
  },
  [theme.breakpoints.down('xs')]: {
    paper: {
      margin: theme.spacing(2),

    }
  }
}));